import { useLocation, useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { ELLIE_CHAT_PATH } from "@/components/companion/features";

// Floating "Back to Ellie" pill on every premium page (except Ellie's own screen).
export const BackToEllie = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (pathname === "/app") return null;
  return (
    <button data-testid="back-to-ellie" onClick={() => navigate(ELLIE_CHAT_PATH)}
      className="fio-glass-strong fixed bottom-24 right-4 z-30 flex sm:right-6 items-center gap-2 rounded-full px-3.5 py-1.5 text-xs font-semibold text-foreground shadow-[0_12px_30px_-12px_rgba(13,148,136,0.55)] transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
      <MessageCircle className="h-4 w-4 text-primary" strokeWidth={2} /> Back to Ellie
    </button>
  );
};
